import { matchPath } from 'react-router-dom';
import { can, canManageMembers, unrestricted } from '../../permissions';

// These paths correspond to Home's actual routes. An ID is never a display label.
export const breadcrumbRoutes = [];
const route = (path, options) => breadcrumbRoutes.push({ path, ...options });
const collections = {
    questionarios: ['Questionários', 'questionarios'],
    elaboradores: ['Elaboradores', 'banca_questoes'],
    membros: ['Membros'], organizadoras: ['Organizadoras'],
    demandas: ['Demandas', 'banca_questoes'], conteudos: ['Conteúdos'],
    modulos: ['Módulos'], treinamentos: ['Treinamentos'],
    recursos: ['Recursos', 'banca_questoes'],
    'avaliar-questoes': ['Avaliar questões', 'banca_questoes'],
    disciplinas: ['Disciplinas', 'disciplinas_questoes'],
    'banca-questoes': ['Banca de questões', 'disciplinas_questoes'],
    system: ['Módulos do sistema'],
};

route('/', { kind: 'home' });
route('/logs-integracao', { title: 'Logs de integração' });
route('/edit_profile', { title: 'Meu perfil' });
route('/minha-organizadora', {title:'Minha organizadora'});
route('/minha-organizadora/editar', {kind: 'myOrganizationEdit'});
Object.keys(collections).forEach(collection => route(`/${collection}`, { collection }));

['register', 'edit', 'show', 'dashboard', 'link'].forEach(action =>
    route(`/instituicao/${action}${action === 'register' ? '' : '/:id'}`, {
        kind: 'institution', action, resource: action === 'register' ? null : 'institution',
    })
);
['register', 'edit', 'show'].forEach(action => route(`/processos/${action}/:id`, {
    kind: 'process', action, resource: action === 'register' ? 'institution' : 'process',
}));

const institutionModules = {
    corretores: ['Corretor', 'corretor', 1], fiscais: ['Fiscal', 'fiscal', 2],
    avaliadores: ['Avaliador', 'avaliador', 3], candidatos: ['Candidato', 'candidato', 4],
};
Object.entries(institutionModules).forEach(([collection, [singular, resource, tab]]) => {
    ['register', 'edit'].forEach(action => route(`/${collection}/${action}/:id`, {
        kind: 'institutionModule', collection, singular, tab, action,
        resource: action === 'register' ? 'institution' : resource,
    }));
});

const globalResources = {
    questionarios: ['Questionário', 'questionario', 'questionarios', false],
    elaboradores: ['Elaborador', 'professor', 'elaboradores', false],
    membros: ['Membro', 'membro', 'membros', false],
    organizadoras: ['Organizadora', 'organizadora', 'organizadoras', false],
    demandas: ['Demanda', 'demanda', 'demandas', true],
    conteudo: ['Conteúdo', 'content', 'conteudos', true],
    modulo: ['Módulo', 'module', 'modulos', true],
    treinamento: ['Treinamento', 'training', 'treinamentos', true],
    disciplinas: ['Disciplina', 'category', 'disciplinas', true],
    recursos: ['Recurso', 'recurso', 'recursos', true],
};
Object.entries(globalResources).forEach(([segment, [singular, resource, collection, hasShow]]) => {
    ['register', 'edit', ...(hasShow ? ['show'] : [])].forEach(action => {
        if (segment === 'treinamento' && action === 'register') return;
        route(`/${segment}/${action}${action === 'register' ? '' : '/:id'}`, {
            kind: 'global', collection, singular, resource: action === 'register' ? null : resource,
            action, showPath: hasShow ? `/${segment}/show` : null,
        });
    });
});
route('/treinamentos/register', { kind: 'global', collection: 'treinamentos', singular: 'Treinamento', action: 'register' });
route('/treinamento/dashboard/:id', { kind: 'trainingReport', resource: 'trainingReport', title: 'Relatório de aprendizagem' });

const processModules = {
    redacoes: ['Redação', 'redacao', 'Redações', 0],
    provas: ['Prova', 'prova', 'Provas', 1],
    diagramacoes: ['Diagramação', 'diagramacao', 'Diagramações', 2],
    entrevistas: ['Entrevista', 'entrevista', 'Entrevistas', 11],
};
Object.entries(processModules).forEach(([segment, [singular, resource, label, tab]]) => {
    ['register', 'edit', 'show'].forEach(action => route(`/${segment}/${action}/:id`, {
        kind: 'processModule', collection: segment, label, singular, tab, action,
        resource: action === 'register' ? 'process' : resource,
        showPath: `/${segment}/show`,
    }));
});
route('/provas/register_existing/:id', {
    kind: 'processModule', collection: 'provas', label: 'Provas', tab: 1,
    resource: 'process', action: 'register_existing', title: 'Importar prova existente',
});
route('/salas/show/:id', { kind: 'processModule', collection: 'salas', label: 'Salas', singular: 'Sala', tab: 4, resource: 'sala', action: 'show' });

const linkedModules = {
    candidatos_vinculados: ['Candidato', 'candidato', 'Candidatos vinculados', 7],
    fiscais_vinculados: ['Fiscal', 'fiscal', 'Fiscais vinculados', 6],
    avaliadores_vinculados: ['Avaliador', 'avaliador', 'Avaliadores vinculados', 9],
    corretores_vinculados: ['Corretor', 'corretor', 'Corretores vinculados', 5],
    questionarios_vinculados: ['Questionário', 'questionario', 'Questionários', 3],
};
Object.entries(linkedModules).forEach(([segment, [singular, resource, label, tab]]) => {
    route(`/${segment}/register/:id`, { kind: 'processModule', collection: segment, singular, label, tab, resource: 'process', action: 'link' });
    if (segment === 'corretores_vinculados') return;
    route(segment === 'questionarios_vinculados' ? `/${segment}/show/:processo_id/:id` : `/${segment}/show/:id/:processo_id`, {
        kind: 'processModule', collection: segment, singular, label, tab, resource,
        action: 'show', linked: true,
    });
});

route('/questoes/register/:id', { kind: 'question', resource: 'category', action: 'register' });
route('/questoes/edit/:id', { kind: 'question', resource: 'questao', action: 'edit' });
route('/questoes/chatbot/:id', { kind: 'question', resource: 'category', action: 'chatbot' });
route('/conteudo/questao/register/:id', { kind: 'contentQuestion', resource: 'content', action: 'register' });
route('/conteudo/questao/edit/:id', { kind: 'contentQuestion', resource: 'contentQuestion', action: 'edit' });
route('/atribuicoes/register/:id', { kind: 'assignment', resource: 'demanda', action: 'register' });
route('/atribuicoes/register_redacoes/:id', { kind: 'assignment', resource: 'demanda', action: 'register_redacoes' });
route('/atribuicoes/show/:id', { kind: 'assignment', resource: 'assignment', action: 'show' });
route('/avaliar-questoes/show/:id', { kind: 'review', resource: 'review', collection: 'avaliar-questoes' });
route('/organizadoras/membros/:id', { kind: 'organizerMembers', resource: 'organizadora', action: 'show' });
route('/organizadoras/membros/register/:id', { kind: 'organizerMembers', resource: 'organizadora', action: 'register' });
route('/organizadoras/membros/edit/:id', { kind: 'organizerMembers', resource: 'cliente', action: 'edit' });
route('/candidatos_errors/edit/:id', { kind: 'conflict', resource: 'conflict', action: 'edit', singular: 'Candidato' });
route('/processos/show_analises/:id', { kind: 'analysis', resource: 'analysis', title: 'Análises faciais' });
route('/processos/show_analises_objetos/:id/:processo_id', { kind: 'analysis', resource: 'objectAnalysis', title: 'Análises de objetos' });

export function getBreadcrumbRoute(pathname) {
    for (const definition of breadcrumbRoutes) {
        const match = matchPath(pathname, { path: definition.path, exact: true });
        if (match) return { ...definition, params: match.params };
    }
    return null;
}

export function getBreadcrumbLabels(user) {
    const changed = !!user?.empresa?.change_text;
    return {
        institution: changed ? 'Processo seletivo' : 'Instituição',
        institutions: changed ? 'Processos Seletivos' : 'Instituições',
        process: changed ? 'Vaga/Cargo' : 'Processo seletivo',
        processes: changed ? 'Vagas/Cargos' : 'Processos Seletivos',
    };
}

export function resourceName(resource) {
    const name = resource?.name || resource?.nome || resource?.nome_prova || resource?.name_default || resource?.title || resource?.titulo || resource?.email;
    return name == null ? '' : String(name).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
}

const resourceRequests = {
    trainingReport: ['treinamento/fiscal', 'training'],
    institution: ['faculdade/get_faculdade', 'faculdade'], process: ['faculdade/get_processo', 'processo'],
    corretor: ['faculdade/get_corretor', 'corretor'], fiscal: ['faculdade/get_fiscal', 'fiscal'],
    avaliador: ['faculdade/get_avaliador', 'avaliador'], candidato: ['faculdade/get_candidato', 'aluno'],
    questionario: ['faculdade/get_questionario', 'questionario'], professor: ['faculdade/get_professor', 'professor'],
    membro: ['faculdade/get_membro', 'membro'], organizadora: ['faculdade/get_organizadora', 'organizadora'],
    demanda: ['faculdade/get_demanda', 'demanda'], content: ['conteudo/get_content', 'data'],
    module: ['modulo/get_module', 'module'], training: ['treinamento/get_training', 'data'],
    category: ['faculdade/get_categoria', 'categoria'], recurso: ['faculdade/get_recurso', 'recurso'],
    redacao: ['faculdade/get_redacao', 'redacao'], prova: ['faculdade/get_prova', 'prova'],
    entrevista: ['faculdade/get_entrevista', 'entrevista'], diagramacao: ['faculdade/get_diagramacao', 'diagramacao'],
    sala: ['faculdade/get_sala', 'sala'], questao: ['faculdade/get_questao', 'questao'],
    contentQuestion: ['conteudo/get_question', 'questao'], assignment: ['faculdade/get_atribuicao', 'demanda_professor'],
    review: ['faculdade/get_questao_review', 'questao'], cliente: ['faculdade/get_cliente', 'cliente'],
    conflict: ['faculdade/get_candidato_error', 'aluno'], analysis: ['faculdade/get_analises_candidato', 'log'],
};

export async function loadBreadcrumbData(routeInfo, get) {
    if (!routeInfo?.resource || !routeInfo.params.id) return {};
    const { params, resource, linked, action } = routeInfo;
    const read = async path => {
        try {
            const response = await get(path);
            return response && !response.error && !response.errors ? response : {};
        } catch (error) { return {}; }
    };
    const fetchResource = async (type, id) => {
        if (!id || !resourceRequests[type]) return null;
        const [path, key] = resourceRequests[type];
        const response = await read(`${path}/${encodeURIComponent(id)}`);
        return response[key] || null;
    };
    let path, key;
    if (resource === 'objectAnalysis') {
        path = `faculdade/get_analises_candidato_objetos/${params.id}/${params.processo_id}`; key = 'user';
    } else if (linked && ['fiscal', 'avaliador'].includes(resource)) {
        path = `faculdade/get_${resource}_detalhes/${params.processo_id}/${params.id}`; key = resource;
    } else if (linked && resource === 'questionario') {
        path = `faculdade/get_questionario_vinculado/${params.processo_id}/${params.id}`; key = 'questionario';
    } else {
        const config = resourceRequests[resource];
        if (!config) return {};
        [path, key] = config;
        if (action === 'show' && ['prova', 'redacao'].includes(resource)) path += '_processo';
        path += `/${encodeURIComponent(params.id)}`;
        if (resource === 'diagramacao') path += '?show=1';
    }
    const response = await read(path);
    const data = { entity: response[key] || null };
    if (routeInfo.kind === 'trainingReport') data.institution = response.instituicao;
    if (!data.entity) return data;
    const entity = data.entity;
    if (routeInfo.kind === 'institution' || resource === 'institution') data.institution = entity;
    if (resource === 'process') data.process = entity;
    if (routeInfo.kind === 'processModule' || routeInfo.kind === 'analysis') {
        data.process = params.processo_id
            ? await fetchResource('process', params.processo_id)
            : data.process || response.processo || entity.processo;
        const processId = params.processo_id || entity.processo_id || data.process?.id;
        if (!params.processo_id && processId && !data.process?.faculdade) data.process = await fetchResource('process', processId) || data.process;
    }
    if (routeInfo.kind === 'institutionModule' || routeInfo.kind === 'conflict') data.institution = data.institution || entity.faculdade;
    const institutionId = data.process?.faculdade_id || entity.faculdade_id;
    data.institution = data.institution || data.process?.faculdade;
    if (!data.institution && institutionId) data.institution = await fetchResource('institution', institutionId);
    if (routeInfo.kind === 'question') data.category = resource === 'category' ? entity : entity.categoria || await fetchResource('category', entity.categoria_id);
    if (routeInfo.kind === 'contentQuestion') data.content = resource === 'content' ? entity : entity.conteudo || await fetchResource('content', entity.conteudo_id);
    if (routeInfo.kind === 'assignment') {
        data.demand = resource === 'demanda' ? entity : response.demanda;
        data.category = response.categoria;
    }
    if (routeInfo.kind === 'organizerMembers') data.organizer = resource === 'organizadora' ? entity : response.organizadora;
    if (routeInfo.kind === 'analysis') data.candidate = resource === 'objectAnalysis' ? entity : entity.user;
    return data;
}

const item = (label, path, module) => ({ label, path, module });
const named = (resource, fallback, path, module) => item(resourceName(resource) || fallback, resource?.id ? `${path}/${encodeURIComponent(resource.id)}` : null, module);
const processPermissions = { provas: 'provas', redacoes: 'redacoes', diagramacoes: 'provas', entrevistas: 'entrevistas', salas: 'candidatos', questionarios_vinculados: 'questionarios', candidatos_vinculados: 'candidatos', fiscais_vinculados: 'fiscais', avaliadores_vinculados: 'avaliadores', corretores_vinculados: 'corretores' };

export function buildBreadcrumbItems(routeInfo, user, data = {}) {
    const labels = getBreadcrumbLabels(user);
    if (!routeInfo) return [];
    if (routeInfo.kind === 'home') return [{ ...item(user?.role === 'viwer' ? 'Diagramações' : labels.institutions), current: true }];
    const { kind, action, collection, singular } = routeInfo;
    const scoped = ['institution', 'process', 'institutionModule', 'processModule', 'conflict', 'analysis', 'trainingReport'].includes(kind);
    const items = [scoped ? item(labels.institutions, '/', 'processo_seletivo') : item('Início', '/', user?.role === 'viwer' ? null : 'processo_seletivo')];
    const institution = () => items.push(named(data.institution, labels.institution, '/instituicao/show', 'processo_seletivo'));
    const process = () => {
        institution();
        items.push(item(labels.processes, data.institution?.id ? `/instituicao/show/${data.institution.id}?tab=0` : null, 'processo_seletivo'));
        items.push(named(data.process, labels.process, '/processos/show', 'processo_seletivo'));
    };
    const entityName = resourceName(data.entity) || singular || 'Detalhes';
    const actionTitle = () => action === 'register' ? `Cadastrar ${singular.toLowerCase()}` : action === 'link' ? `Vincular ${singular.toLowerCase()}` : action === 'edit' ? `Editar ${singular.toLowerCase()}` : entityName;
    if (kind === 'institution') {
        if (action !== 'register') institution();
        if (action !== 'show') {
            if (action === 'link') items.push(item('Treinamentos', data.institution?.id && user?.empresa?.plan?.training ? `/instituicao/show/${data.institution.id}?tab=5` : null));
            items.push(item({ register: `Cadastrar ${labels.institution.toLowerCase()}`, edit: `Editar ${labels.institution.toLowerCase()}`, dashboard: 'Dashboard de resultados', link: 'Vincular treinamentos' }[action]));
        }
    } else if (kind === 'process') {
        if (action === 'register') {
            institution();
            items.push(item(labels.processes, data.institution?.id ? `/instituicao/show/${data.institution.id}?tab=0` : null, 'processo_seletivo'));
        } else process();
        if (action !== 'show') items.push(item(`${action === 'edit' ? 'Editar' : 'Cadastrar'} ${labels.process.toLowerCase()}`));
    } else if (kind === 'institutionModule' || kind === 'conflict') {
        institution();
        const tab = kind === 'conflict' ? 4 : routeInfo.tab;
        const label = kind === 'conflict' ? 'Candidatos' : { corretores: 'Corretores', fiscais: 'Fiscais', avaliadores: 'Avaliadores', candidatos: 'Candidatos' }[collection];
        items.push(item(label, data.institution?.id ? `/instituicao/show/${data.institution.id}?tab=${tab}` : null, kind === 'conflict' ? 'candidatos' : collection));
        items.push(item(kind === 'conflict' ? `Resolver conflito: ${entityName}` : action === 'edit' ? `Editar ${entityName}` : actionTitle()));
    } else if (kind === 'processModule') {
        process();
        items.push(item(routeInfo.label, data.process?.id ? `/processos/show/${data.process.id}?tab=${routeInfo.tab}` : null, processPermissions[collection]));
        if (action === 'edit' && routeInfo.showPath) items.push(named(data.entity, singular, routeInfo.showPath, processPermissions[collection]));
        const title = routeInfo.title || (routeInfo.resource === 'sala' && data.entity?.numero != null ? `Sala ${data.entity.numero}` : actionTitle());
        items.push(item(title));
    } else if (kind === 'trainingReport') {
        institution();
        items.push(item('Treinamentos', data.institution?.id && user?.empresa?.plan?.training ? `/instituicao/show/${data.institution.id}?tab=5` : null));
        items.push(named(data.entity, 'Treinamento', '/treinamento/show'));
        items.push(item(routeInfo.title));
    } else if (kind === 'question') {
        items.push(item('Disciplinas', '/disciplinas', 'disciplinas_questoes'));
        items.push(named(data.category, 'Disciplina', '/disciplinas/show', 'disciplinas_questoes'));
        items.push(item({ register: 'Cadastrar questão', edit: 'Editar questão', chatbot: 'Criar questão com IA' }[action]));
    } else if (kind === 'contentQuestion') {
        items.push(item('Conteúdos', '/conteudos'));
        items.push(named(data.content, 'Conteúdo', '/conteudo/show'));
        items.push(item(action === 'edit' ? 'Editar questão' : 'Cadastrar questão'));
    } else if (kind === 'assignment') {
        items.push(item('Demandas', '/demandas', 'banca_questoes'));
        items.push(named(data.demand, 'Demanda', '/demandas/show', 'banca_questoes'));
        items.push(item(action === 'show' ? `Questões atribuídas${resourceName(data.entity?.professor) ? ` a ${resourceName(data.entity.professor)}` : ''}` : action === 'register_redacoes' ? 'Atribuir redações' : 'Atribuir questões'));
    } else if (kind === 'myOrganizationEdit') {
        items.push(item('Minha organizadora', '/minha-organizadora', 'portal_configuracoes'));
        items.push(item('Editar dados'));
    } else if (kind === 'organizerMembers') {
        items.push(item('Organizadoras', '/organizadoras'));
        items.push(item(resourceName(data.organizer) || 'Organizadora'));
        items.push(item('Membros', action !== 'show' && data.organizer?.id ? `/organizadoras/membros/${data.organizer.id}` : null));
        if (action !== 'show') items.push(item(action === 'edit' ? `Editar ${entityName}` : 'Cadastrar membro'));
    } else if (kind === 'analysis') {
        process();
        items.push(item('Candidatos vinculados', data.process?.id ? `/processos/show/${data.process.id}?tab=7` : null, 'candidatos'));
        items.push(item(resourceName(data.candidate) || 'Candidato', data.candidate?.id && data.process?.id ? `/candidatos_vinculados/show/${data.candidate.id}/${data.process.id}` : null, 'candidatos'));
        items.push(item(routeInfo.title));
    } else if (collection) {
        const [label, module] = collections[collection] || [collection];
        items.push(item(label, `/${collection}`, module));
        if (kind === 'review') items.push(item('Avaliar questão'));
        else if (action) {
            if (['edit', 'dashboard'].includes(action) && routeInfo.showPath) items.push(named(data.entity, singular, routeInfo.showPath, module));
            items.push(item(action === 'dashboard' ? 'Dashboard do treinamento' : action === 'edit' && !routeInfo.showPath ? `Editar ${entityName}` : actionTitle()));
        }
    } else items.push(item(routeInfo.title || 'Detalhes'));

    return items.filter(entry => entry.label).map((entry, index, list) => {
        const accessible = (!entry.module || can(user, entry.module)) && (entry.module !== 'questionarios' || user?.role === 'region_admin' || !user?.empresa?.hide_questionario);
        const members = entry.path?.startsWith('/membros') ? canManageMembers(user) : true;
        const organizer = entry.path?.startsWith('/organizadoras') ? user?.role === 'region_admin' : true;
        const general = entry.path && ['/conteudo', '/modulo', '/treinamento', '/system'].some(prefix => entry.path.startsWith(prefix)) ? unrestricted(user) : true;
        return { ...entry, path: index === list.length - 1 || !accessible || !members || !organizer || !general || (entry.path?.startsWith('/treinamento') && !user?.empresa?.plan?.training) ? null : entry.path, current: index === list.length - 1 };
    });
}
